import React, { useState, useEffect } from 'react';
import { Link, Outlet, Route } from 'react-router-dom';
import ROUTES from '../../nav/Routes';
import { useNavigate } from "react-router-dom";


const ToggleB = () => {
    let sidebar = document.querySelector('.Sideheader');
    let AdminB = document.querySelector('.bodyContainer');
    let name = document.querySelectorAll('.name');

    sidebar.classList.toggle('Sideheader1');
    AdminB.classList.toggle('bodyContainer1');
    name.forEach((name) => {
        name.classList.toggle('name1');
    });
};



function AdminLayout() {
    const navigate = useNavigate();

    useEffect(() => {
        const isLogin = localStorage.getItem("isLogin");
        if (isLogin !== "true") {
            navigate("/login"); // Redirect to login if not logged in
        }
    }, [navigate]);


    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    const sidebarClass = isSidebarOpen ? 'Sideheader1' : 'Sideheader';
    const adminBClass = isSidebarOpen ? 'bodyContainer1' : 'bodyContainer';
    const nameClass = isSidebarOpen ? 'name1' : 'name';
    return (
        <div>
            <div className="AdminMContainer">
                <div className="Sideheader">
                    <button className="btn2" onClick={ToggleB}>
                        <i className="fa-solid fa-bars-staggered"></i>
                    </button>

                    <ul>
                        <li>
                            <Link className="anchor" title="Home Page" to={ROUTES.adminhome.name}>
                                <i className="fa-solid fa-house-chimney "></i>{' '}
                                <span className="name">Home</span>{' '}
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="anchor"
                                title="Contact List"
                                to={ROUTES.contactlist.name}
                            >
                                <i className="fa-solid fa-envelope-open-text"></i>{' '}
                                <span className="name">Contact List</span>
                            </Link>
                        </li>

                        {/* <li>
                            <Link
                                className="anchor"
                                title="Blog List"
                                to={ROUTES.adminhome.name}
                            >
                                <i className="fa-solid fa-newspaper"></i>{' '}
                                <span className="name">Blog List</span>
                            </Link>
                        </li> */}
                        <li>
                            <Link
                                className="anchor"
                                title="Team Member List"
                                to={ROUTES.CareerApplicationList.name}
                            >
                                <i className="fa-solid fa-users"></i>
                                <span className="name">Career Application List</span>{' '}
                            </Link>
                        </li>

                        <li>
                            <Link
                                className="anchor"
                                title="Log Off from Admin panel & Go to Home Page"
                                onClick={() => {
                                    localStorage.removeItem("isLogin");
                                    window.location.href = "/login";  // Or "/"
                                }}
                            >
                                <i className="fa-solid fa-power-off"></i>{' '}
                                <span className="name">Log Out</span>{' '}
                            </Link>
                        </li>

                        <li></li>
                    </ul>
                </div>
                <div className="bodyContainer">
                    <div className="AdminContainer">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;
